/* IFG eCommerce 23/09/2026 - Servizi aggiuntivi nel carrello (Entrupy, ozono).
   Vedi snippets/ifg-cart-servizi.liquid. Aggiunge il servizio collegato a un articolo
   e rimuove i servizi rimasti senza articolo. Usa solo le API AJAX del carrello e
   l'evento cart:refresh del tema: nessuna modifica a theme.js. */
(function () {
  if (window.ifgCartServizi) return;
  window.ifgCartServizi = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;

  function refresh() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    if (window.themeVariables && themeVariables.settings && themeVariables.settings.pageType === 'cart') {
      window.location.reload();
    }
  }

  function pulisci(cart) {
    if (busy || !cart || !cart.items) return;
    var presenti = {};
    cart.items.forEach(function (i) { presenti[String(i.variant_id)] = true; });
    var updates = {};
    var n = 0;
    cart.items.forEach(function (i) {
      var per = i.properties && i.properties._per;
      if (per && !presenti[String(per)]) { updates[i.key] = 0; n++; }
    });
    if (!n) return;
    busy = true;
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () { busy = false; refresh(); }).catch(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ifg-servizio]');
    if (!btn || busy) return;
    e.preventDefault();
    busy = true;
    btn.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{
        id: Number(btn.getAttribute('data-ifg-servizio')),
        quantity: 1,
        properties: { 'Per': btn.getAttribute('data-ifg-titolo'), '_per': btn.getAttribute('data-ifg-per') }
      }] })
    }).then(function () { busy = false; refresh(); })
      .catch(function () { busy = false; btn.removeAttribute('aria-busy'); });
  });

  document.addEventListener('cart:change', function (e) {
    if (e.detail && e.detail.cart) pulisci(e.detail.cart);
  });

  fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(pulisci).catch(function () {});
})();
